// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SoundOutlinedSvg from "@fishx/icons-svg/es/asn/SoundOutlined";
import FishxIcon from '../components/FishxIcon';

var SoundOutlined = function SoundOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: SoundOutlinedSvg
  }));
};

SoundOutlined.displayName = 'SoundOutlined';
export default React.forwardRef(SoundOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/SoundOutlined.js
// module id = 4173
// module chunks = 0